import { render, staticRenderFns } from "./ResponsiveImageSet.vue?vue&type=template&id=7b1626c3&lang=pug"
import script from "./ResponsiveImageSet.vue?vue&type=script&lang=ts"
export * from "./ResponsiveImageSet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default})
